<template>
  <div class="mx-auto mt-10 mb-10 max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 gap-4">
      <div class="grid grid-cols-1 gap-2">
        <h1
          class="mb-3 text-xl font-extrabold tracking-tight text-gray-900 sm:text-2xl md:text-3xl"
        >
          <span class="text-blue-ribbon-500">FAQ</span>
        </h1>
        <Disclosure
          v-for="(faq, faqKey) in faqs"
          :key="`faq-${faqKey}`"
          v-slot="{ open }"
        >
          <DisclosureButton
            class="flex w-full justify-between rounded-lg bg-blue-ribbon-50 px-4 py-2 text-left text-sm font-medium text-blue-ribbon-600 hover:bg-blue-ribbon-200 focus:outline-none focus-visible:ring focus-visible:ring-blue-ribbon-500 focus-visible:ring-opacity-75"
          >
            <span>{{ faq.question }}</span>
            <ChevronUpIcon
              :class="open ? 'rotate-180 transform' : ''"
              class="h-5 w-5 text-blue-ribbon-600"
            />
          </DisclosureButton>
          <DisclosurePanel class="px-4 pt-2 pb-2 text-sm text-gray-500">
            <div v-html="faq.answer" />
          </DisclosurePanel>
        </Disclosure>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head'

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronUpIcon } from '@heroicons/vue/solid'
import { faqs } from './../graphcms/content.json'

useHead({
  title: 'FAQ - GaragesNear.me',
  meta: [
    {
      name: 'og:title',
      content: 'FAQ - GaragesNear.me'
    },
    {
      name: 'og:image',
      content: '/open-graph/hero.webp'
    },
    {
      name: 'og:image:alt',
      content: 'GaragesNear.me banner'
    },
    {
      name: 'og:image:width',
      content: 1280
    },
    {
      name: 'og:image:height',
      content: 576
    }
  ]
})
</script>
